var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#002FA7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1543 20.0024L16.6714 15.6926C16.5479 15.5743 16.48 15.416 16.48 15.2472C16.48 15.0783 16.5479 14.9201 16.6714 14.8016L17.0642 14.4241C17.1874 14.3054 17.3522 14.24 17.5277 14.24C17.7033 14.24 17.8679 14.3054 17.9912 14.4241L23.3289 19.5553C23.4527 19.6742 23.5205 19.8332 23.52 20.0021C23.5205 20.1719 23.4528 20.3306 23.3289 20.4496L17.9962 25.5759C17.8728 25.6946 17.7083 25.76 17.5326 25.76C17.3571 25.76 17.1925 25.6946 17.0691 25.5759L16.6763 25.1984C16.4208 24.9527 16.4208 24.5528 16.6763 24.3073L21.1543 20.0024Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.4200d971bfb9ad6548fac9a9614de553.svg";
export { ForwardRef as ReactComponent };